import yup, {
    cardNameValidator,
    imageValidator,
    arrayValidator,
    stringValidator,
    booleanValidator,
} from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.max(300).required(),
        image: imageValidator(nullable),
        rarity: stringValidator.required(),
        inventoryLimit: yup.number().required(),
        value: yup.number().required(),
        use: arrayValidator.min(1, '* at lease one effect must be checked.'),
        isRotational: booleanValidator,
    });
